<!-- begin:: Header Mobile -->
<div id="kt_header_mobile" class="kt-header-mobile kt-header-mobile--fixed">
  <div class="kt-header-mobile__logo">
    <a routerLink="/">
      <img alt="logo" [attr.src]="headerLogo" />
    </a>
  </div>
  <div class="kt-header-mobile__toolbar">
    <button
      [matMenuTriggerFor]="scanTo"
      class="quick-scan btn btn-sm btn-secondary"
    >
      Scan
    </button>
    <mat-menu #scanTo="matMenu" xPosition="before">
      <button mat-menu-item (click)="toScan()">Sku</button>
      <button mat-menu-item (click)="scanLocation()">Location</button>
    </mat-menu>

    <button
      [hidden]="!asideDisplay"
      class="kt-header-mobile__toggler kt-header-mobile__toggler--left"
      id="kt_aside_mobile_toggler"
    >
      <span></span>
    </button>
  </div>
</div>
<!-- end:: Header Mobile -->
